import { deepClone } from '@/utils/deepClone';

export interface IListItem {
  id: string;
}

export default class ListClass<T extends IListItem> {
  private $data: T[] = [];
  private $current: T | undefined = undefined;
  get data() {
    return this.$data;
  }
  get current() {
    return this.$current;
  }
  public deleteItemById(itemId: string) {
    const findIndex = this.$data.findIndex((item) => item.id === itemId);
    if (findIndex > -1) {
      this.$data.splice(findIndex, 1);
    }
    if (this.$current?.id === itemId) {
      this.$current = undefined;
    }
  }
  public findItemById(ItemId: string): T | undefined {
    if (!ItemId) {
      return;
    }
    return this.$data.find((item) => item.id === ItemId);
  }
  public changeCurrent(item: T | undefined) {
    this.$current = item;
  }
  public checkItemIsInData(itemId: string): boolean {
    return this.$data.findIndex((item) => item.id === itemId) > -1;
  }
  public clearData() {
    this.$data.length = 0;
    this.$current = undefined;
  }
  public pushItemList(items: T[]) {
    this.$data.push(...items);
  }
  public unshiftItem(item: T) {
    this.$data.unshift(item);
  }
  public initData(items: T[]) {
    this.$data = deepClone(items);
  }
  public updateItem(newItem: T) {
    Object.assign(this.$data.find((item) => item.id === newItem.id)!, {...newItem});
    if (this.$current && this.$current.id === newItem.id) {
      this.changeCurrent({...newItem});
    }
  }
}
